const createType = (perfix: string) => {
  return {
    REQUEST: perfix + '_REQUEST',
    SUCCESS: perfix + '_SUCCESS',
    FAILED: perfix + '_FAILED'
  };
};

export const GET_FEEDBACK_LIST = createType('GET_FEEDBACK_LIST');
export const GET_FEEDBACK_DETAIL = createType('GET_FEEDBACK_DETAIL');
export const GET_FEEDBACK_DETAIL_V2 = createType('GET_FEEDBACK_DETAIL_V2');

// 获取客户列表
export const CUSTOMER_LIST = createType('CUSTOMER_LIST');
// 获取用户列表
export const EMPLOYEE_LIST = createType('EMPLOYEE_LIST');
// 获取PM用户列表
export const PM_EMPLOYEE_LIST = createType('PM_EMPLOYEE_LIST');
//获取产品Value列表
export const System_Display_LIST=createType("System_Display_LIST");
// 获取项目名称列表
export const PROJECT_LIST = createType('PROJECT_LIST');
// 获取所属子系统
export const PORDUCT_SBUSYSTEM_LIST = createType('PORDUCT_SBUSYSTEM_LIST');
// 获取模块
export const PORDUCT_MODULE_LIST = createType('PORDUCT_MODULE_LIST');
// 获取产品版本
export const PORDUCT_EDITION_LIST = createType('PORDUCT_EDITION_LIST');

// 获取所有所属子系统 (包括禁用数据)
export const PORDUCT_SBUSYSTEM_ALL_LIST = createType('PORDUCT_SBUSYSTEM_ALL_LIST');
// 获取所有模块 (包括禁用数据)
export const PORDUCT_MODULE_ALL_LIST = createType('PORDUCT_MODULE_ALL_LIST');
// 获取所有产品版本 (包括禁用数据)
export const PORDUCT_EDITION_ALL_LIST = createType('PORDUCT_EDITION_ALL_LIST');

export const COMMIT_PRODUCT_FEEDBACK = createType('COMMIT_PRODUCT_FEEDBACK');
export const UPDATE_PRODUCT_FEEDBACK = createType('UPDATE_PRODUCT_FEEDBACK');
export const FEEDBACK_TOTAL = createType('FEEDBACK_TOTAL');
// 获取子系统列表
export const GET_SUBSYSTEM = createType('GET_SUBSYSTEM');
// 获取经办人列表
export const GET_ASSIGNEE = createType('GET_ASSIGNEE');
// 获取经办人默认列表
export const GET_DEFAULT_ASSIGNEE = createType('GET_DEFAULT_ASSIGNEE');
// 保存默认经办人
export const ADD_DEFAULT_ASSIGNEE = createType('ADD_DEFAULT_ASSIGNEE');
// 获取经办人设置权限
export const GET_ASSIGNEE_PERMISSIONS = createType('GET_ASSIGNEE_PERMISSIONS');
// 撤销反馈
export const REVOKE_FEEDBACK = createType('REVOKE_FEEDBACK');
// 转单
export const TRANSFER_FEEDBACK = createType('TRANSFER_FEEDBACK');

// 满意度评价
export const ADD_FeedbackSatisfaction = createType('ADD_FeedbackSatisfaction');

// 获取满意度评价
export const GET_FeedbackSatisfaction = createType('GET_FeedbackSatisfaction');

// 更新是否首次
export const UPDATE_FIRST_PRODUCT_FEEDBACK = createType('UPDATE_FIRST_PRODUCT_FEEDBACK');

// 判断转单信息是否存在
export const EXIST_FEEDBACKSTRANSFER = createType('EXIST_FEEDBACKSTRANSFER');
// 保存转单信息是否存在
export const SAVE_FEEDBACKSTRANSFER = createType('SAVE_FEEDBACKSTRANSFER');
// 获取转单信息
export const GET_FEEDBACKSTRANSFER = createType('GET_FEEDBACKSTRANSFER');

// 转单接收
export const RECEIVE_FEEDBACKSTRANSFER = createType('RECEIVE_FEEDBACKSTRANSFER');
// 转单拒收
export const REJECTION_FEEDBACKSTRANSFER = createType('REJECTION_FEEDBACKSTRANSFER');
// 转单催接收
export const URGE_FEEDBACKSTRANSFER = createType('URGE_FEEDBACKSTRANSFER');
// 转单撤单
export const CANCEL_FEEDBACKSTRANSFER = createType('CANCEL_FEEDBACKSTRANSFER');
// 外部接口新增反馈信息
export const SAVE_FEEDBACKBYEXTERNAL = createType('SAVE_FEEDBACKBYEXTERNAL');
// 判断用户是否是区域人员
export const IS_PRODUCTUSER = createType('IS_PRODUCTUSER');
//判断是否具有提交bug权限
export const IS_SUBMITBUGBYUSER=createType('IS_SUBMITBUGBYUSER');
// 获取模块默认经办人信息
export const GET_DEFAULTASSIGNEEBYMODULE=createType('GET_DEFAULTASSIGNEEBYMODULE');
//保存模块默认经办人信息
export const SAVE_DEFAULTASSIGNEEBYMODULE=createType('SAVE_DEFAULTASSIGNEEBYMODULE');